<template>
    <div class="wdsb">
        <!--我的预约-->
        <img class="pa-top" src="../../assets/images/pa-top.png" alt=""/>

    <div class="info-box">
      <div class="title">填写资料</div>
      <div class="twonum">
        <div class="num1">
            <span class="num1-txt">配额数：</span>
            <span style="color:#FD4A46">{{sqdata.num1}}</span>
        </div>
        <div class="num2">
            <span class="num2-txt">已申报数：</span>
            <span style="color:#FD4A46">{{sqdata.num2}}</span>
        </div>
      </div>
      <div class="form-box">
        <van-form @submit="onSubmit">
          <div class="flex-box">
            <span class="label">申请单位</span>
            <van-field
              v-model="formData.sqdw"
              name="申请单位"
              placeholder="请输入申请单位"
              :rules="[{ required: true, message: '请输入申请单位' }]"
            >
            </van-field>
          </div>
          <div class="flex-box">
            <!-- <span class="label">预约日期</span>
            <van-field
              v-model="formData.yytime"
              name="选择日期"
              placeholder="选择日期"
              :rules="[{ required: true, message: '选择日期' }]"
            >
            </van-field> -->


            <span class="label">预约日期</span>
            <van-field
              readonly
              clickable
              name="datetimePicker"
              :value="formData.yyrq"
              
              placeholder="点击选择时间"
              @click="showPicker = true"
            />
            <van-popup v-model="showPicker" position="bottom">
              <van-datetime-picker
                type="date"
                @confirm="onConfirm"
                @cancel="showPicker = false"
                :min-date="minDate"
                :max-date="maxDate"
              />
            </van-popup>
          </div>
          <div class="flex-box">
            <span class="label">预约人数</span>
            <van-field
              v-model="formData.yyrs"
              name="预约人数"
              placeholder="请输入"
              :rules="[{ required: true, message: '预约人数' }]"
            >
            </van-field>
          </div>
          <div class="flex-box">
            <span class="label">领队姓名</span>
            <van-field
              v-model="formData.ldxm"
              name="领队姓名"
              placeholder="请输入姓名"
              :rules="[{ required: true, message: '领队姓名' }]"
            >
            </van-field>
          </div>
          <div class="flex-box">
            <span class="label">手机号</span>
            <van-field
              v-model="formData.phone"
              name="手机号"
              placeholder="请输入手机号"
              :rules="[
                { required: true, message: '请输入手机号' },
                {
                  message: '手机格式错误',
                  pattern: new RegExp(/^(?:(?:\+|00)86)?1[3-9]\d{9}$/)
                }
              ]"
              type="tel"
            >
            </van-field>
          </div>
          <div class="license">
            <div class="label">上传图片</div>
            <div class="tip">
                <span class="tip-txt">请上传图片</span>
            </div>
            <van-field
              name="uploader"
              :rules="[{  message: '上传图片' }]"
            >
              <template #input> 
                <van-uploader name="uploader" v-model="formData.license" :max-count="3" :after-read="afterRead" :before-delete="afterDelete" :before-read="beforeRead">
                    <div class="up-img-box">
                        <img width="70" height="70" src="../../assets/images/pa-ex.png" alt="" srcset="" />
                        <!-- <img class="up-img" width="70" height="70" src="../../assets/images/pa-ex.png" alt="" srcset="" />
                        <img class="up-img" width="70" height="70" src="../../assets/images/pa-ex.png" alt="" srcset="" /> -->
                    </div>
                  <template #preview-cover="{ file }">
                    <div class="preview-cover van-ellipsis">
                      {{ file.name }}
                    </div>
                  </template>
                </van-uploader>
              </template>
            </van-field>
          </div>
          <div style="margin: 16px;">
            <Button round block type="info" native-type="submit" style="backgroundColor: #FD4A46;border: none;">立即提交</Button>
          </div>
        </van-form>
      </div>
      <div class="bottom-tip">提示：不好意思，当天预约次数已满！</div>
    </div>

    <div class="empt"></div>

    <van-tabbar v-model="active" >
            <van-tabbar v-model="active" active-color="#FD4A46">
                <van-tabbar-item @click="tabsTo(1)">
                    <span>首页</span>
                    <template #icon="props">
                        <img v-if="props.active" src="../../assets/images/ph-11.png" alt="">
                        <img v-else src="../../assets/images/t-01.png" alt="">
                    </template>
                </van-tabbar-item>
                <van-tabbar-item @click="tabsTo(2)">
                    <span>申报</span>
                    <template #icon="props">
                        <img v-if="props.active" src="../../assets/images/sq1.png" alt="">
                        <img v-else src="../../assets/images/sq0.png" alt="">
                    </template>
                </van-tabbar-item>
                <van-tabbar-item icon="search" @click="tabsTo(3)">
                    <span>我的</span>
                    <template #icon="props">
                        <img v-if="props.active" src="../../assets/images/my.png" alt="">
                        <img v-else src="../../assets/images/t-02.png" alt="">
                    </template>
                </van-tabbar-item>
            </van-tabbar>
    </van-tabbar>

    <div class="bg" v-if="bgshow">
        <div class="bgcontent">
            <div class="title">恭喜您</div>
            <div class="bimg">
                <img src="../../assets/images/success@2x.png" alt="">
            </div>
            <div class="title2">预约成功</div>
            <div class="btn" @click="changeBg">关闭</div>
        </div>
    </div>




    </div>
</template>

<script>

import mix1 from '@/mixins/page'
import { Field, Popup, Button, NumberKeyboard, Swipe, SwipeItem, Lazyload, Card, Tabbar, TabbarItem, List, Toast, Form, DatetimePicker,Uploader} from 'vant'
export default {
    mixins: [mix1],
    name: 'DeclarationIndex',
    components: {
        // MgPopup,
        Button,
        [Button.name]: Button,
        [Field.name]: Field,
        [Popup.name]: Popup,
        NumberKeyboard,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Lazyload.name]: Lazyload,
        [Card.name]: Card,
        [Tabbar.name]: Tabbar,
        [TabbarItem.name]: TabbarItem,
        [List.name]: List,
        [Form.name]: Form,
        [DatetimePicker.name]:DatetimePicker,
        [Uploader.name]: Uploader,
    },
    data(){
        return {
            active: 1,
            formData: {
                sqdw: "",
                yyrq: "",
                yyrs: "",
                ldxm:"",
                phone:'',
                license: [],
            },
            sqdata:{
                num1:100,
                num2:10,
            },
            currentDate: new Date(),
            showPicker: false,
            minDate: new Date(2024, 1, 1),
            maxDate: new Date(2026, 1, 1),
            bgshow:true,
        }
    },
    methods:{
        changeBg(){
            this.bgshow = false
        },
        tabsTo(type) {
            if (type == 1) {
                this.$router.push('/')
            } else if(type == 2) {
                this.$router.push('/declaration/index')
            }
             else {
                this.$router.push('/my/index')
            }
        },
        onSubmit(){
            alert('需要对接api才能继续')
        },
        onConfirm(time) {
          console.log(time)

          let s = new Date(time)
	        const startDate = s.getFullYear() + '-' + this.p((s.getMonth() + 1)) + '-' + 	this.p(s.getDate())
	        console.log(startDate)	//2023-06-01

          this.formData.yytime = startDate;
          this.showPicker = false;
        },

        p(m){
	          return m < 9 ? '0'+ m : m
	        },
         
          async beforeRead(file){
            let data = file.content
            console.log('beforeRead-file', file)
            console.log('data', data)
        },

        afterDelete(...args) {
            console.log('afterDelete-args', args)
            // let index = args[1].index
            // this.detailInfo.items[this.upLoadIndex].imgs.splice(index, 1)
            return true
        },

        afterRead(...args){
            console.log('afterRead-args', args)
            let size = 2097152
            if(args[0].size > size){
            this.uiAlert('上传图片不能大于2MB')
            return
            }
            // return true
        },  

    }
}
</script>

<style lang="less">
.wdsb{
    padding: 0px 20px 36px;
    .pa-top{
        width: 100%;
        height: 314px;
        padding-top: 20px;
        border-radius: 15px;
    }

    .info-box {
        margin-top: 16px;
        background-color: #fff;
    .title {
        text-align: center;
        font-weight: bold;
        font-size: 18px;
        color: #38251e;
        line-height: 31px;
        padding-top: 27px;
        padding-bottom: 29px;
    }
    .twonum{
        margin: 0 auto;
        // border: 1px solid red;
        width: 510px;
        height: 60px;
        display: flex;
        justify-content: space-between;
        .num1,.num2{
            width: 226px;
            height: 60px;
            background-color: #F5F5F5;
            border-radius: 30px 30px 30px 30px;
            display: flex;
            align-items:center;
            justify-content: center;
        }
        .num1-txt,.num2-txt{
            // width: 162px;
            height: 40px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 11px;
            color: #030303;
            line-height: 40px;
            text-align: center;
            font-style: normal;
            text-transform: none;   
        }
    }
    .flex-box {
         display: flex;
         align-items: center;
         margin-bottom: 20px;
    .label {
      display: block;
      width: 200px;
      text-align: center;
      font-size: 15px;
      color: #000000;
    }
  }
  .license{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-bottom: 20px;
    .label {
      display: block;
      width: 160px;
      text-align: center;
      font-size: 15px;
      color: #000000;
      margin-bottom: 20px;
    }
    .tip{
        width: 710px;
        .tip-txt{
            display: inline-block;
            width: 160px;
            text-align: center;
            // margin-left:13px;
            color:#C8C8C8;
            font-size:11px
        }
    }
  }
  .up-img-box{
    margin-left: 26px;
    width: 454px;
    height: 140px;
    display: flex;
    .up-img{
        margin-left: 17px;
    }
  }
  .bottom-tip{
    margin: 0 auto;
    margin-top: 30px;
    width: 476px;
    height: 40px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 11px;
    color: #FD4A46;
    line-height: 0px;
    text-align: center;
    font-style: normal;
    text-transform: none;

  }
  }
  .empt{
    height: 100px;
  }
  .bg{
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(70, 70, 70, 0.3);
    .bgcontent{
        width: 632px;
        height: 613px;
        background: #FFFFFF;
        border-radius: 15px 15px 15px 15px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        .title{
            width: 632px;
            height: 46px;
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 16px;
            color: #000000;
            line-height: 46px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            text-align: center;
            margin-top: 66px;
        }
        .bimg{
            width: 96px;
            height: 96px;
            margin-top: 45px;
            img{
                display: block;
                width: 96px;
                height: 96px;
            }
        }
        .title2{
            width: 632px;
            height: 54px;
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 19px;
            color: #FD4A46;
            line-height: 54px;
            text-align: center;
            font-style: normal;
            text-transform: none;
        }
        .btn{
            width: 441px;
            height: 88px;
            line-height: 88px;
            background: #FD4A46;
            border-radius: 44px 44px 44px 44px;
            text-align: center;
            color: #FFFFFF;
            font-size: 16px;
        }
    }
  }
    
}

</style>